module.exports = __webpack_public_path__ + "img/im_download_image.08fd71b2.jpg";